import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import { gigCountryProvinceApi } from '@/api';
import { vocabApi } from '@/api/vocab';
import type { IThunkAPI } from '@/store/types';
import type { IGigCountry, IGigCountryAdmin } from '@/store/admin/types/types';
import type { IVocabCountry } from '@/store/slices/vocab/types';

const initialState: IGigCountryAdmin = {
  countryList: [],
  showForm: false,
  isError: false,
  isSuccess: false,
  isFetching: false,
};

export const getGigCountryList = createAsyncThunk<any, number, IThunkAPI>(
  'get/gig/id/country/list',
  async (gigId: number, thunkAPI) => {
    try {
      // const response = await gigCountryApi.getGigCountryList(gigId);
      const [gigCountry, gigProvince, country] = await Promise.all([
        gigCountryProvinceApi.getGigCountryList(gigId),
        gigCountryProvinceApi.getGigProvinceList(gigId),
        vocabApi.getCountryList(),
      ]);

      // return response.data;
      return {
        gigCountryList: gigCountry.data,
        gigProvinceList: gigProvince.data,
        countryList: country.data,
      }; // response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getGigProvinceList = createAsyncThunk<unknown, number, IThunkAPI>(
  'get/gig/id/country/list',
  async (gigId: number, thunkAPI) => {
    try {
      // const response = await gigCountryApi.getGigCountryList(gigId);
      const [gigCountry, country] = await Promise.all([
        gigCountryProvinceApi.getGigCountryList(gigId),
        vocabApi.getCountryList(),
      ]);

      // return response.data;
      return { gigCountryList: gigCountry.data, countryList: country.data }; // response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const gigCountrySlice = createSlice({
  name: 'gigCountryAdmin',
  initialState,
  reducers: {
    clearGigCountries(state) {
      state.countryList = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getGigCountryList.pending, state => {
        state.isFetching = true;
      })
      .addCase(getGigCountryList.fulfilled, (state, action) => {
        state.isFetching = false;
        state.isSuccess = true;
        const { gigCountryList, gigProvinceList, countryList } = action.payload;
        const newCountryList = gigCountryList.map((g: IGigCountry) => {
          const country = countryList.filter((c: IVocabCountry) => c.id === g.countryId)[0];
          return {
            ...g,
            country: country,
            provinceList: gigProvinceList.filter((p: any) => p.countryId === g.countryId),
          };
        });
        state.countryList = newCountryList;
      });
  },
});

// actions
export const { clearGigCountries } = gigCountrySlice.actions;

// selectors
export const gigCountryListAll = (state: RootState): IGigCountryAdmin['countryList'] =>
  state.gigCountryAdmin.countryList;

export default gigCountrySlice.reducer;
